export enum UserRole {
  ITAdmin = 3,
  AOAdmin = 9,
  AoResponsibleOfficer = 18,
  OfqualRecognitionAdmin = 24,
  AORegulationTeam = 26,
  OfqualRecognitionExpansionAdmin = 33,
  OfqualRecognitionExpansionReader = 34,
}

const OfqualRoles = [
  UserRole.ITAdmin,
  UserRole.OfqualRecognitionAdmin,
  UserRole.OfqualRecognitionExpansionAdmin,
  UserRole.OfqualRecognitionExpansionReader,
];

const AoRoles = [
  UserRole.AOAdmin,
  UserRole.AoResponsibleOfficer,
  UserRole.AORegulationTeam,
];
const readRoles = [
  UserRole.ITAdmin,
  UserRole.AOAdmin,
  UserRole.AoResponsibleOfficer,
  UserRole.AORegulationTeam,
  UserRole.OfqualRecognitionExpansionAdmin,
  UserRole.OfqualRecognitionExpansionReader,
];

const AllRoles = [...OfqualRoles, ...AoRoles];

export { OfqualRoles, AllRoles, AoRoles, readRoles };
